export const frontmatter = {
    "draft": false,
    "title": "Guide: Widgets",
    "description": "How to create and configure a WebChat widget in OnnIA: appearance, behavior, FAQs, integration, and states.",
    "sidebar_label": "Widgets",
    "sidebar_group": "reference",
    "sidebar_order": 7
}

export const toc = [
    {
        "depth": 2,
        "id": "module-access",
        "value": "Module access"
    },
    {
        "depth": 2,
        "id": "create-a-widget",
        "value": "Create a widget"
    },
    {
        "depth": 3,
        "id": "general-data",
        "value": "General data"
    },
    {
        "depth": 3,
        "id": "frequently-asked-questions-faq",
        "value": "Frequently Asked Questions (FAQ)"
    },
    {
        "depth": 3,
        "id": "visibility-and-position",
        "value": "Visibility and position"
    },
    {
        "depth": 3,
        "id": "typography-and-colors",
        "value": "Typography and colors"
    },
    {
        "depth": 3,
        "id": "images-and-attachments",
        "value": "Images and attachments"
    },
    {
        "depth": 2,
        "id": "preview",
        "value": "Preview"
    },
    {
        "depth": 2,
        "id": "widget-states",
        "value": "Widget states"
    }
]